<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">贝利婴幼儿发展量表第四版中文·筛查版2.0统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <div class="main-body column">
      <div class="header">
        <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span class="name">认知、语言、动作测试</span>
        </div>
      </div>
      <div class="body">
        <a-form-model ref="form" :model="formModel" autoComplete="off" :label-col="labelCol" :wrapper-col="wrapperCol"
          labelAlign="left">

          <!-- 标签页切换 -->
          <a-tabs v-model="activeTab" @change="handleTabChange">
            <a-tab-pane key="cg" tab="认知(CG)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('cg') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in cgItems" :key="'cg-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('cg', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ cgTitles[ageConfig[currentAgeGroup].cgOffset + index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('cg', index)"
                      @change="handleScoreChange('cg', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="rc" tab="语言-接受性沟通(RC)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('rc') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in rcItems" :key="'rc-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('rc', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ rcTitles[ageConfig[currentAgeGroup].rcOffset + index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('rc', index)"
                      @change="handleScoreChange('rc', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="ec" tab="语言-表达性沟通(EC)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('ec') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in ecItems" :key="'ec-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('ec', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ ecTitles[ageConfig[currentAgeGroup].ecOffset + index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('ec', index)"
                      @change="handleScoreChange('ec', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="fm" tab="动作-精细动作(FM)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('fm') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in fmItems" :key="'fm-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('fm', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ fmTitles[ageConfig[currentAgeGroup].fmOffset + index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('fm', index)"
                      @change="handleScoreChange('fm', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="gm" tab="动作-粗大动作(GM)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('gm') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in gmItems" :key="'gm-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('gm', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ gmTitles[ageConfig[currentAgeGroup].gmOffset + index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('gm', index)"
                      @change="handleScoreChange('gm', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>

          <!-- 原始表单字段，现在隐藏起来，用于提交 -->
          <div style="display: none;">
            <a-form-model-item label="认知(CG)" prop="simple.score_cg">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_cg" class="cu-input1 input-number-100" :min="0"
                  :max="60" />
                <span class="num-de"><0-60></span>
              </div>
            </a-form-model-item>
            <a-form-model-item label="语言-接受性沟通(RC)" prop="simple.score_rc">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_rc" class="cu-input1 input-number-100" :min="0"
                  :max="44" />
                <span class="num-de"><0-44></span>
              </div>
            </a-form-model-item>
            <a-form-model-item label="语言-表达性沟通(EC)" prop="simple.score_ec">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_ec" class="cu-input1 input-number-100" :min="0"
                  :max="46" />
                <span class="num-de"><0-46></span>
              </div>
            </a-form-model-item>
            <a-form-model-item label="动作-精细动作(FM)" prop="simple.score_fm">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_fm" class="cu-input1 input-number-100" :min="0"
                  :max="54" />
                <span class="num-de"><0-54></span>
              </div>
            </a-form-model-item>
            <a-form-model-item label="动作-粗大动作(GM)" prop="simple.score_gm">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_gm" class="cu-input1 input-number-100" :min="0"
                  :max="54" />
                <span class="num-de"><0-54></span>
              </div>
            </a-form-model-item>
          </div>

          <div style="display: flex;align-items: center;justify-content: center; margin-top: 20px;">
            <div class="btn" @click="actionData">{{ id != '' ? '编辑并生成报告' : '保存并生成报告' }}</div>
          </div>
        </a-form-model>
      </div>
    </div>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import { Save, Detail, Update } from '../../commonApi';
import { base, simple, simpleRule } from "../simple-field";
import { message } from "ant-design-vue";
import * as Api from "../base-info/api";
import moment from "moment";

export default {
  data() {
    return {
      activeTab: 'cg', // 默认选中认知标签页
      // 各个测试项目的题目数据（根据年龄动态初始化）
      cgItems: [],
      rcItems: [],
      ecItems: [],
      fmItems: [],
      gmItems: [],

      // 年龄配置：0-13个月、14-24个月、25-42个月
      ageConfig: {
        '0-13': { cg: 24, rc: 14, ec: 14, fm: 24, gm: 30, cgOffset: 0, rcOffset: 0, ecOffset: 0, fmOffset: 0, gmOffset: 0 },
        '14-24': { cg: 20, rc: 13, ec: 14, fm: 10, gm: 12, cgOffset: 24, rcOffset: 14, ecOffset: 14, fmOffset: 24, gmOffset: 30 },
        '25-42': { cg: 18, rc: 17, ec: 19, fm: 16, gm: 14, cgOffset: 44, rcOffset: 27, ecOffset: 28, fmOffset: 34, gmOffset: 42 }
      },
      calculatedAgeDays: 0, // 计算后的测试年龄（天数）
      currentAgeGroup: '0-13', // 当前年龄组

      // 题目标题数据 - 包含所有年龄段的题目
      // 0-13个月：认知24题，接受性14题，表达性14题，精细动作24题，粗大动作30题
      // 14-24个月：认知20题，接受性13题，表达性14题，精细动作10题，粗大动作12题
      // 25-42个月：认知18题，接受性17题，表达性19题，精细动作16题，粗大动作14题
      cgTitles: [
        // 0-13个月 (24题)
        '被抱起时平静下来', '注视物体', '辨认照护者', '对照护者的离开作出反应', '注意转移',
        '表现出视觉偏好', '对周围环境的反应', '探索物体', '将物体拿到嘴边', '与镜像进行互动',
        '伸手够/拿到物体', '敲打物体', '拍打桌子', '寻找坠物', '捡起并握住积木',
        '预期注视', '摇铃', '捡起另一块积木', '寻找消失的物品', '寻找隐藏的物品',
        '透明盒子', '插板：2根胶棒', '粉色板', '蓝色板',
        // 14-24个月 (20题，认知取前20题)
        '寻找消失的物品', '寻找隐藏的物品', '透明盒子', '插板系列：2根胶棒', '关联游戏：自己',
        '粉色板系列：2块', '专心听故事', '蓝色板系列：1块', '关联游戏：他人', '积木系列：9块积木',
        '插板系列：6根胶棒', '粉色板系列：3块', '用铅笔获取物体', '蓝色板系列：4块', '表征性游戏',
        '匹配图片', '空间记忆：3张卡', '匹配3种颜色', '假想性游戏', '概念分组：颜色',
        // 25-42个月 (18题，认知取前18题)
        '积木系列：9块积木', '粉色板系列：3块', '表征性游戏', '反转的粉色板', '空间记忆：3张卡',
        '模仿一个2步的动作', '匹配3种颜色', '假想性游戏', '理解"1"的概念', '概念分组：颜色',
        '概念分组：大小', '匹配大小', '数数（一 一对应）', '区分大小', '区分图形',
        '数数（基数）', '分类物体', '完成颜色匹配'
      ],
      rcTitles: [
        // 0-13个月 (14题)
        '注视人片刻', '对周围声音的反应', '辨认照护者', '对人声有反应', '对照护者的反应',
        '区分声音', '敲打物体', '对名字有应答', '听辨词语', '对日常社交要求有应答',
        '识别物品', '识别环境中的物品', '识别身体部位', '遵循一步指令',
        // 14-24个月 (13题，RC取前13题)
        '敲打物体', '对名字有应答', '听辨词语', '识别物品', '识别图片系列：3个正确',
        '识别身体部位', '遵循一步指令', '识别图片系列：6个正确', '娃娃部位：5个正确', '识别动作：3个正确',
        '理解物体用途', '理解代词（你、我、她的、我的、你的）', '理解介词',
        // 25-42个月 (17题，RC取前17题)
        '识别环境中的物品', '识别身体部位', '遵循一步指令', '娃娃部位系列：5个正确', '理解物体用途',
        '识别动作系列：6个正确', '理解代词（你、我、她的、我的、你的）', '理解大小', '理解介词',
        '理解现在正在进行的动作', '识别颜色', '理解复数形式', '理解更多', '理解最多',
        '理解否定', '理解过去完成的动作', '理解较少'
      ],
      ecTitles: [
        // 0-13个月 (14题)
        '未分化发音', '社会性发声或笑', '发出元音', '吸引关注/互动', '发出辅音',
        '辅音-元音结合', '使用肢体语言', '含糊不清的话', '使用单一近似词', '引导他人对物体的关注',
        '模仿词语', '合理使用词语', '用词语表达意愿', '物品命名',
        // 14-24个月 (14题，EC取前14题)
        '合理使用词语', '用词语表达意愿', '理解度：50%', '物品命名', '图片命名',
        '回答是否题', '模仿双词句（两个词的句子）', '说出双词句（两个词的句子）', '说出3个词的句子', '使用代词',
        '使用不同的词语组合', '动作命名：5个正确', '提出问题', '确定所属关系',
        // 25-42个月 (19题，EC取前19题)
        '辅音-元音结合', '使用肢体语言', '使用单一近似词', '理解度：50%', '物品命名',
        '图片命名', '回答是否题', '说出双词句（两个词的句子）', '理解度：75%', '说出3个词的句子',
        '使用代词', '提出问题', '使用不同的词语组合', '动作命名：5个正确', '确定所属关系',
        '颜色命名', '说出物体用途', '使用介词', '说出4个词或5个词的句子'
      ],
      fmTitles: [
        // 0-13个月 (24题)
        '目光追随移动的人', '目光追随吊环：水平方向', '目光追随吊环：纵向', '尝试伸手入口', '手握吊环',
        '头随吊环转动', '目光追随铅笔：水平方向', '保持双手张开', '手掌抓握反射', '旋转手腕',
        '抓握悬吊的环', '伸手拿/碰积木', '积木抓握：整手抓握', '看着食物粒', '抓食物粒系列：整手抓握',
        '将积木或圆环换手', '自主进食', '积木抓握系列：拇指-指尖抓握', '抓食物粒系列：灵巧钳式抓握', '抓握铅笔：手掌抓握',
        '手指戳插板', '翻书', '搭积木：2块积木', '将食物粒放进瓶子里',
        // 14-24个月 (10题，FM取前10题)
        '翻书', '抓握铅笔系列：手掌抓握', '主动涂画', '搭积木系列：2块积木', '将食物粒放进瓶子里',
        '将硬币投入存钱罐', '抓握铅笔系列：静态三点握笔', '搭积木系列：6块积木', '模仿画画系列：横线和竖线', '模仿画画系列：圆形',
        // 25-42个月 (16题，FM取前16题)
        '抓握铅笔系列：手掌抓握', '搭积木系列：2块积木', '将硬币投入存钱罐', '抓握铅笔系列：静态三点握笔',
        '搭积木系列：6块积木', '模仿画画系列：横线和竖线', '搭积木系列：8块积木', '模仿画画系列：圆形',
        '搭火车', '穿积木', '搭桥', '模仿画加号', '解扣纽扣', '临摹图形', '模仿画正方形', '临摹正方形'
      ],
      gmTitles: [
        // 0-13个月 (30题)
        '伸展双臂和双腿', '控制头部：保持头部直立3秒', '控制头部：俯卧悬空', '控制头部：保持头部直立15秒', '俯卧时控制头部：45°',
        '纠正头部位置', '翻身：从俯卧到仰卧', '俯卧时撑起胸部', 'ATNR非对称性紧张性颈反射', '前倾时降落伞反射',
        '俯卧时头部控制：90°', '扶坐：30秒', '翻身：从仰卧到侧卧', '独坐：10秒', '站立：背部竖直',
        '拉起至坐位', '翻身：从仰卧到俯卧', '独坐：30秒', '爬行：腹部', '从坐位转为手膝位',
        '支撑体重', '爬行：爬行动作', '拉起自己至站立', '有支撑行走', '有支撑侧身走',
        '有控制地坐下', '独站', '行走：没有帮助', '独立蹲下', '上楼梯系列：无需支撑，两步一级',
        // 14-24个月 (12题，GM取前12题)
        '行走：没有帮助', '向前扔球', '上楼梯系列：无需支撑，两步一级', '下楼梯系列：无需支撑，两步一级', '协调地跑', '踢球',
        '跳：双脚跳', '向前跳：15厘米', '无需支撑，单脚平衡站立系列：2秒', '在步行带上行走：倒着走', '上楼梯系列：无需支撑，双脚交替', '无需支撑，单脚平衡站立系列：6秒',
        // 25-42个月 (14题，GM取前14题)
        '行走：没有帮助', '向前扔球', '下楼梯系列：无需支撑，两步一级', '协调地跑', '跳系列：从楼梯最低一级跳下', '踢球',
        '跳：双脚跳', '向前跳系列：15厘米', '无需支撑，单脚平衡站立系列：2秒', '踮脚走路', '上楼梯系列：无需支撑，双脚交替',
        '下楼梯系列：无需支撑，双脚交替', '单脚跳1.5米', '向前跳系列：60厘米'
      ],

      // 原有数据
      scoreCdTip: '<0-119>',
      scoreCdMax: 119,
      scoreBDBool: false,
      scoreCOBool: false,
      scoreDSBool: false,
      labelCol: { span: 8, style: { color: '#7E8589', fontWeight: '500' } },
      wrapperCol: { span: 14 },
      formModel: {
        base: Object.assign({}, base),
        simple: Object.assign({}, simple),
      },
      isUnit: 1, // 是否关联
      bindListVisible: false,
      id: '',
      source: ''
    }
  },
  mounted() {
    // 编辑
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
    } else {
      this.formModel.base = JSON.parse(window.localStorage.getItem('base_info'));
      // 新建模式：根据年龄初始化题目数量
      this.initItemsByAge();
    }
    if (this.$route.query && this.$route.query.source) {
      this.source = this.$route.query.source;
    }
    this.scoreBDBool = false
    this.scoreCOBool = false
    this.scoreDSBool = false
    if (this.formModel.simple.simple_sub_test_num === 4) {
      this.formModel.simple.score_bd = null;
      this.formModel.simple.score_co = null;
      this.scoreBDBool = true
      this.scoreCOBool = true
    } else if (this.formModel.simple.simple_sub_test_num === 5) {
      this.formModel.simple.score_ds = null;
      this.scoreDSBool = true;
    }
  },
  methods: {
    // 根据年龄初始化题目数量
    initItemsByAge() {
      const baseInfo = this.formModel.base;
      
      // 计算测试年龄天数
      const testDate = new Date(baseInfo.test_date);
      let bornDate;
      
      if (baseInfo.is_premature_infant === 1) {
        // 早产儿：用预产期计算
        bornDate = new Date(baseInfo.expected_date);
      } else {
        // 非早产儿：用出生日期计算
        bornDate = new Date(baseInfo.born_date);
      }
      
      this.calculatedAgeDays = Math.floor((testDate - bornDate) / (1000 * 60 * 60 * 24));
      
      // 根据天数确定年龄组
      let ageGroup;
      if (this.calculatedAgeDays < 13 * 30 + 30) { // 小于13个月（约390天）
        ageGroup = '0-13';
      } else if (this.calculatedAgeDays < 24 * 30 + 30) { // 14-24个月（约720天）
        ageGroup = '14-24';
      } else {
        ageGroup = '25-42';
      }
      
      // 根据年龄组初始化题目数量
      const config = this.ageConfig[ageGroup];
      this.currentAgeGroup = ageGroup;
      this.cgItems = this.initItems(config.cg);
      this.rcItems = this.initItems(config.rc);
      this.ecItems = this.initItems(config.ec);
      this.fmItems = this.initItems(config.fm);
      this.gmItems = this.initItems(config.gm);
    },

    // 初始化题目数据
    initItems(count) {
      const items = [];
      for (let i = 1; i <= count; i++) {
        items.push({
          itemNo: i.toString(),
          score: null
        });
      }
      return items;
    },

    // 处理标签页切换
    handleTabChange(activeKey) {
      this.activeTab = activeKey;
    },

    // 处理分数变更
    handleScoreChange(type, index) {
      const items = this[`${type}Items`];

      // 如果选择了某一题，则之前的题目自动满分
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          if (items[i].score === null) {
            items[i].score = 2; // 自动设为满分
          }
        }
      }

      // 检查是否触发终止规则（连续5题选0）
      this.checkTerminationRule(type);

      // 更新总分到原表单
      this.updateTotalScore();
    },

    // 检查终止规则
    checkTerminationRule(type) {
      const items = this[`${type}Items`];
      let consecutiveZeros = 0;
      for (let i = 0; i < items.length; i++) {
        if (items[i].score === 0) {
          consecutiveZeros++;
          if (consecutiveZeros >= 4) { // 从5改为4
            // 触发终止规则，后面的题目无法作答
            // 清空后续题目的选择值
            for (let j = i + 1; j < items.length; j++) {
              items[j].score = null;
            }
            break;
          }
        } else {
          consecutiveZeros = 0;
        }
      }
    },

    // 判断题目是否禁用
    isItemDisabled(type, index) {
      const items = this[`${type}Items`];

      // 检查前面是否有连续3个0分
      let consecutiveZeros = 0;
      for (let i = 0; i < index; i++) {
        if (items[i].score === 0) {
          consecutiveZeros++;
          if (consecutiveZeros >= 3) { // 从5改为3
            return true; // 禁用当前题目
          }
        } else {
          consecutiveZeros = 0;
        }
      }

      return false;
    },

    // 获取总分
    getTotalScore(type) {
      const items = this[`${type}Items`];
      let total = null;
      let consecutiveZeros = 0;

      for (const item of items) {
        // 连续3个0分后，后续分数不参与统计
        if (consecutiveZeros >= 3) {
          break;
        }
        if (item.score !== null) {
          if (total === null) {
            total = 0;
          }
          total += item.score;
          if (item.score === 0) {
            consecutiveZeros++;
          } else {
            consecutiveZeros = 0;
          }
        }
      }

      return total;
    },

    // 更新总分到原表单
    updateTotalScore() {
      const cgScore = this.getTotalScore('cg');
      const rcScore = this.getTotalScore('rc');
      const ecScore = this.getTotalScore('ec');
      const fmScore = this.getTotalScore('fm');
      const gmScore = this.getTotalScore('gm');
      
      // 当分数为0时，提交null
      this.formModel.simple.score_cg = cgScore;
      this.formModel.simple.score_rc = rcScore;
      this.formModel.simple.score_ec = ecScore;
      this.formModel.simple.score_fm = fmScore;
      this.formModel.simple.score_gm = gmScore;
    },
    handleRadio() {
      this.scoreBDBool = false
      this.scoreCOBool = false
      this.scoreDSBool = false
      if (this.formModel.simple.simple_sub_test_num === 4) {
        this.formModel.simple.score_bd = null;
        this.formModel.simple.score_co = null;
        this.scoreBDBool = true
        this.scoreCOBool = true
      } else if (this.formModel.simple.simple_sub_test_num === 5) {
        this.formModel.simple.score_ds = null;
        this.scoreDSBool = true;
      }
    },

    async getDetail() {
      const res = await Detail({ id: this.id });
      if (res && res.code == 0) {
        this.formModel.simple = Object.assign({}, res.bayleyScreeningAssessment);
        this.formModel.base = {
          id: res.bayleyScreeningAssessment.id,
          name: res.bayleyScreeningAssessment.name,
          scoring_num: res.bayleyScreeningAssessment.scoring_num,
          gender: res.bayleyScreeningAssessment.gender,
          test_date: res.bayleyScreeningAssessment.test_date,
          born_date: res.bayleyScreeningAssessment.born_date,
          real_age: res.bayleyScreeningAssessment.real_age,
          is_premature_infant: res.bayleyScreeningAssessment.is_premature_infant,
          expected_date: res.bayleyScreeningAssessment.expected_date,
          adjustment_age: res.bayleyScreeningAssessment.adjustment_age,
          examiner_name: res.bayleyScreeningAssessment.examiner_name,
          caregivers_name: res.bayleyScreeningAssessment.caregivers_name,
          relationship_of_child: res.bayleyScreeningAssessment.relationship_of_child,
          relationship_remark: res.bayleyScreeningAssessment.relationship_remark,
          referral_remark: res.bayleyScreeningAssessment.referral_remark,
        }

        // 编辑模式：先根据年龄初始化题目数量
        this.initItemsByAge();
        // 再根据已有分数初始化题目
        this.initItemsFromScores();
      }
    },

    // 从已有分数初始化题目
    initItemsFromScores() {
      try {
        // 如果有 answer_data 字段，则从中解析题目数据
        if (this.formModel.simple.answer_data) {
          const answerData = JSON.parse(this.formModel.simple.answer_data);

          // 更新各个测试项目的题目数据
          if (answerData.cg && Array.isArray(answerData.cg)) {
            this.cgItems = answerData.cg;
          }

          if (answerData.rc && Array.isArray(answerData.rc)) {
            this.rcItems = answerData.rc;
          }

          if (answerData.ec && Array.isArray(answerData.ec)) {
            this.ecItems = answerData.ec;
          }

          if (answerData.fm && Array.isArray(answerData.fm)) {
            this.fmItems = answerData.fm;
          }

          if (answerData.gm && Array.isArray(answerData.gm)) {
            this.gmItems = answerData.gm;
          }
        } else {
          // 如果没有 answer_data，但有总分，可以尝试根据总分推算
          // 这里可以根据实际业务逻辑添加推算代码
          console.log('没有详细题目数据，只有总分');
        }
      } catch (error) {
        console.error('解析 answer_data 出错:', error);
        // 解析出错时，保持默认初始化的题目数据
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatToYMD(dateStr) {
      // 分割日期和时间
      const datePart = dateStr.split('T')[0];
      return datePart;
    },

    async actionData() {
      // 提交前更新总分
      this.updateTotalScore();

      // 检查是否至少填写了一个分测验
      const hasCgData = this.cgItems.some(item => item.score !== null);
      const hasRcData = this.rcItems.some(item => item.score !== null);
      const hasEcData = this.ecItems.some(item => item.score !== null);
      const hasFmData = this.fmItems.some(item => item.score !== null);
      const hasGmData = this.gmItems.some(item => item.score !== null);

      if (!hasCgData && !hasRcData && !hasEcData && !hasFmData && !hasGmData) {
        message.error('请至少完成一个分测验');
        return;
      }

      // 新增：验证所有未禁用的题目都必须填写
      const validateRequiredItems = (items, typeName) => {
        for (let i = 0; i < items.length; i++) {
          const isDisabled = this.isItemDisabled(typeName, i);
          if (!isDisabled && items[i].score === null) {
            return {
              valid: false,
              message: `${this.getTypeDisplayName(typeName)}分测验未满足终止条件`
            };
          }
        }
        return { valid: true };
      };

      // 验证各个测试项目
      const testTypes = [
        { items: this.cgItems, type: 'cg', hasData: hasCgData },
        { items: this.rcItems, type: 'rc', hasData: hasRcData },
        { items: this.ecItems, type: 'ec', hasData: hasEcData },
        { items: this.fmItems, type: 'fm', hasData: hasFmData },
        { items: this.gmItems, type: 'gm', hasData: hasGmData }
      ];

      for (const testType of testTypes) {
        // 只验证有数据的测试项目
        if (testType.hasData) {
          const validation = validateRequiredItems(testType.items, testType.type);
          if (!validation.valid) {
            message.error(validation.message);
            return;
          }
        }
      }

      // 准备提交的答题数据，过滤掉未作答的题目（保持为null）
      const answerData = {
        cg: this.cgItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score // 如果未选择，这里就是null
        })),
        rc: this.rcItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score
        })),
        ec: this.ecItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score
        })),
        fm: this.fmItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score
        })),
        gm: this.gmItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score
        }))
      };

      // 将答题数据转换为JSON字符串
      this.formModel.simple.answer_data = JSON.stringify(answerData);

      // 继续原有的提交逻辑
      console.log(this.formModel.simple);
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let res = null;
          if (this.formModel.base.born_date) {
            this.formModel.base.born_date = this.formatToYMD(this.formModel.base.born_date);
          }
          if (this.formModel.base.test_date) {
            this.formModel.base.test_date = this.formatToYMD(this.formModel.base.test_date);
          }
          if (this.formModel.base.expected_date) {
            this.formModel.base.expected_date = this.formatToYMD(this.formModel.base.expected_date);
          }
          if (this.id) {
            res = await Update({ base: this.formModel.base, assessment: this.formModel.simple });
          } else {
            res = await Save({ base: this.formModel.base, assessment: this.formModel.simple });
          }
          if (res && res.code == 0) {
            window.localStorage.removeItem('base_info');
            message.success({ content: res.message });
            setTimeout(() => {
              if (this.id == '') {
                this.$router.push({ path: "/" });
              } else if (this.id != '' && this.source == 'index') {
                this.$router.push({ path: "/" });
              } else if (this.id != '' && this.source == 'history') {
                this.$router.push({ path: "/maintain-history-report" });
              }
            }, 1500);
          }
        } else {
          message.error({ content: '表单验证未通过' });
        }
      });
    },

    // 新增辅助方法：获取测试类型的显示名称
    getTypeDisplayName(type) {
      const typeNames = {
        'cg': '认知(CG)',
        'rc': '语言-接受性沟通(RC)',
        'ec': '语言-表达性沟通(EC)',
        'fm': '动作-精细动作(FM)',
        'gm': '动作-粗大动作(GM)'
      };
      return typeNames[type] || type;
    }
  }
};
</script>
<style>
/* 标签页内容样式 */
.tab-content {
  padding: 20px 0;
}

.score-summary {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #832C75;
}

.score-label {
  margin-right: 10px;
}

.items-container {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 10px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.item-row:last-child {
  border-bottom: none;
}

.item-row.disabled {
  opacity: 0.5;
  background-color: #f5f5f5;
}

.item-label {
  font-weight: 500;
  color: #333;
  flex: 1; /* 让标题占据更多空间 */
  margin-right: 10px; /* 与选项组之间的间距 */
}
</style>
<style scoped>
.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}

.flex {
  display: flex;
}

.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 70px;
  justify-content: center;
}

.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #832C75;
  margin-bottom: 20px;
}

.cu-select {
  line-height: 42px;
  height: 42px;
}

.btn {
  background: #832C75;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 80px;
}

.btn.sh {
  border: 1px solid #832B75;
  border-radius: 5px;
  font-weight: 400;
  color: #832B75;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}

.ant-form-item {
  margin-bottom: 12px !important;
}
</style>
